import { useEffect, useId, useState } from 'react'

const inputCls =
  'rounded-md border border-slate-200 bg-white px-2 py-1.5 text-[12px] text-slate-700 ' +
  'focus:border-amber-400 focus:outline-none'

// Same roster fetch GeoTagsReport and MajorEventsReport each had their own copy of --
// soh_coverage is the fullest vehicle_id list already exposed as a report.
function useVehicleRoster(): string[] {
  const [vehicles, setVehicles] = useState<string[]>([])
  useEffect(() => {
    let live = true
    fetch('/api/reports/soh_coverage?limit=500')
      .then((r) => (r.ok ? (r.json() as Promise<{ rows?: { vehicle_id: string }[] }>) : null))
      .then((d) => {
        if (!live || !d?.rows) return
        setVehicles([...new Set(d.rows.map((r) => r.vehicle_id))].sort())
      })
      .catch(() => undefined)
    return () => { live = false }
  }, [])
  return vehicles
}

/**
 * Type-to-search vehicle picker. A plain <select> over 70+ registration numbers meant
 * scrolling to find one; this is a text input against a <datalist> of the same roster --
 * typing narrows the suggestion list natively, with a clear button once something's picked.
 */
export function VehicleSearchField({
  value,
  onChange,
  label = 'vehicle',
}: {
  value: string
  onChange: (vehicleId: string) => void
  label?: string
}): JSX.Element {
  const vehicles = useVehicleRoster()
  const listId = useId()

  return (
    <label className="flex flex-col gap-1 text-[10.5px] font-medium uppercase tracking-wide text-slate-500">
      {label}
      <span className="flex items-center gap-1">
        <input
          type="search"
          list={listId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="MH18BZ…"
          className={`${inputCls} w-[200px] font-mono normal-case`}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            aria-label="clear vehicle filter"
            title="clear"
            className="rounded px-1 py-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
          >
            ×
          </button>
        )}
      </span>
      <datalist id={listId}>
        {vehicles.map((v) => (
          <option key={v} value={v} />
        ))}
      </datalist>
    </label>
  )
}
